import { render, staticRenderFns } from "./ProductPropertyView.vue?vue&type=template&id=581c3114&"
import script from "./ProductPropertyView.vue?vue&type=script&lang=js&"
export * from "./ProductPropertyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports